import React from 'react';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Travcations brand lockup.
 *
 * The official logo PNG (765×174, aspect ratio ≈ 4.40:1) already contains the
 * bird mark + "Travcations" wordmark + "Let's Explore to Experience" tagline
 * baked in. We simply render the image at the requested height — no separate
 * text rendering, no padding-left math.
 */
const LOGO_RATIO = 4.40; // width / height of the brand-lockup PNG

const SIZES = {
  sm: 36,
  md: 56,
  lg: 76,
  xl: 100,
};

export default function BrandLockup({
  company,
  size = 'md',
  align = 'left',
  forPdf = false,
}) {
  if (!company) return null;

  const logoH = SIZES[size] || SIZES.md;
  const logoSrc = company.logoUrl?.startsWith('http')
    ? company.logoUrl
    : `${API_BASE}${company.logoUrl || '/api/uploads/travcations-logo.png'}`;

  const wrapperAlign = {
    left: 'items-start',
    center: 'items-center',
    right: 'items-end',
  }[align] || 'items-start';

  return (
    <div className={`inline-flex flex-col ${wrapperAlign}`} style={{ lineHeight: 1 }}>
      <img
        src={logoSrc}
        alt={company.companyName || 'Travcations'}
        crossOrigin={forPdf ? 'anonymous' : undefined}
        style={{
          height: `${logoH}px`,
          width: `${logoH * LOGO_RATIO}px`,
          display: 'block',
          objectFit: 'contain',
          imageRendering: '-webkit-optimize-contrast',
        }}
        onError={(e) => { e.currentTarget.style.display = 'none'; }}
      />
    </div>
  );
}
